function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "error-illustration_svg__a",
  x1: "27.291%",
  x2: "95.682%",
  y1: "36.261%",
  y2: "77.638%"
}, /*#__PURE__*/React.createElement("stop", {
  offset: "0%",
  stopColor: "#FEB31A"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "37%",
  stopColor: "#FE9823"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "70%",
  stopColor: "#FE852A"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "error-illustration_svg__b",
  x1: "0%",
  x2: "100%",
  y1: "50%",
  y2: "50%"
}, /*#__PURE__*/React.createElement("stop", {
  offset: "0%",
  stopColor: "#F4543C"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "24%",
  stopColor: "#F45D43"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "64%",
  stopColor: "#F67755"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "73%",
  stopColor: "#F67D5A"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "error-illustration_svg__c",
  x1: "19.04%",
  x2: "103.238%",
  y1: "34.736%",
  y2: "76.206%"
}, /*#__PURE__*/React.createElement("stop", {
  offset: "0%",
  stopColor: "#FFF8C6"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "20%",
  stopColor: "#FFF3BD"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "53%",
  stopColor: "#FFE6A3"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "80%",
  stopColor: "#FFD98A"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "error-illustration_svg__d",
  x1: "0%",
  x2: "100%",
  y1: "50%",
  y2: "50%"
}, /*#__PURE__*/React.createElement("stop", {
  offset: "0%",
  stopColor: "#F4543C"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "24%",
  stopColor: "#F45D43"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "64%",
  stopColor: "#F67755"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "73%",
  stopColor: "#F67D5A"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "error-illustration_svg__e",
  x1: "26.908%",
  x2: "89.709%",
  y1: "34.736%",
  y2: "76.206%"
}, /*#__PURE__*/React.createElement("stop", {
  offset: "0%",
  stopColor: "#FFF8C6"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "20%",
  stopColor: "#FFF3BD"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "53%",
  stopColor: "#FFE6A3"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "80%",
  stopColor: "#FFD98A"
})));

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(2.422 .755)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 48.75,
  cy: 49.356,
  r: 42.074,
  stroke: "#ABC0D8",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2.123,
  opacity: 0.5
}), /*#__PURE__*/React.createElement("circle", {
  cx: 48.75,
  cy: 49.356,
  r: 32.786,
  stroke: "#ABC0D8",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2.123,
  opacity: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 25.728,
  cy: 84.476,
  r: 4.063,
  fill: "#FFF",
  fillRule: "nonzero",
  stroke: "#ABC0D8",
  strokeWidth: 2.123
}), /*#__PURE__*/React.createElement("circle", {
  cx: 2.902,
  cy: 75.536,
  r: 2.902,
  stroke: "#F1823B",
  strokeWidth: 2.123
}), /*#__PURE__*/React.createElement("circle", {
  cx: 88.34,
  cy: 34.646,
  r: 2.902,
  fill: "#F1823B",
  fillRule: "nonzero"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FDB913",
  fillRule: "nonzero",
  d: "M91.446 3.348L94.032.762a.806.806 0 011.14 0l2.587 2.586a.807.807 0 010 1.141l-2.586 2.586a.807.807 0 01-1.14 0l-2.587-2.587a.806.806 0 010-1.14zM66.822 95.648l1.703-1.703a.52.52 0 01.735 0l1.703 1.703a.52.52 0 010 .735l-1.703 1.703a.52.52 0 01-.735 0l-1.703-1.703a.52.52 0 010-.735zM13.515 20.263l2.158-2.158a.669.669 0 01.946 0l2.156 2.157a.67.67 0 01.001.947l-2.156 2.156a.67.67 0 01-.948 0l-2.157-2.156a.67.67 0 01.001-.947zM90.34 79.952l2.157-2.156a.67.67 0 01.947-.001l2.156 2.157a.67.67 0 010 .947l-2.156 2.157a.67.67 0 01-.947 0l-2.157-2.158a.669.669 0 010-.946z"
})), /*#__PURE__*/React.createElement("g", {
  fillRule: "nonzero",
  transform: "translate(.188 18.333)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "url(#error-illustration_svg__a)",
  d: "M54.641 0c.88 0 1.592.713 1.592 1.592 0 .81-.608 1.489-1.437 1.584l-.155.008h-2.066l.001 5.325c11.67.817 20.885 10.543 20.885 22.421 0 12.414-10.063 22.477-22.477 22.477S28.507 43.344 28.507 30.93c0-11.878 9.214-21.604 20.885-22.42l-.001-5.326h-2.064a1.592 1.592 0 01-1.585-1.438l-.007-.154c0-.81.608-1.489 1.438-1.584L47.327 0z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#error-illustration_svg__b)",
  d: "M25.442 37.682a1.062 1.062 0 01.124 2.116l-.124.007H5.705a1.061 1.061 0 01-.123-2.115l.123-.008h19.737zM6.866 30.716a1.062 1.062 0 01.124 2.116l-.124.007H1.061a1.06 1.06 0 01-.123-2.115l.123-.008h5.805zm24.381 0a1.063 1.063 0 01.124 2.116l-.124.007H11.51a1.061 1.061 0 01-.123-2.115l.123-.008h19.737zm5.805-6.965a1.062 1.062 0 01.124 2.115l-.124.008H17.315a1.062 1.062 0 01-.123-2.116l.123-.007h19.737zm-24.38 0a1.06 1.06 0 01.123 2.115l-.124.008H6.866a1.062 1.062 0 01-.123-2.116l.123-.007h5.805z"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 50.984,
  cy: 30.93,
  r: 8.429,
  fill: "url(#error-illustration_svg__c)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#error-illustration_svg__d)",
  d: "M58.516 21.746a1.061 1.061 0 011.602 1.387l-.087.1-8.29 8.441a1.06 1.06 0 01-1.602-1.386l.088-.101 8.29-8.44z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#error-illustration_svg__e)",
  d: "M50.89 48.772c.542 0 .99.407 1.05.93l.007.123v3.19c0 .583-.473 1.054-1.057 1.054-.542 0-.99-.407-1.05-.93l-.007-.123v-3.19c0-.582.473-1.054 1.057-1.054zm-12.818-5.29c.381.38.41.978.088 1.39l-.088.1-2.267 2.258c-.412.41-1.082.41-1.495 0a1.05 1.05 0 01-.088-1.39l.088-.1 2.267-2.257a1.06 1.06 0 011.495 0zm27.031-.087l.1.088 2.267 2.257a1.05 1.05 0 010 1.49 1.06 1.06 0 01-1.396.087l-.1-.087-2.266-2.258a1.05 1.05 0 010-1.49 1.06 1.06 0 011.395-.087zm8.176-13.732c.584 0 1.058.472 1.058 1.053 0 .54-.409.986-.934 1.047l-.124.007h-3.203a1.056 1.056 0 01-1.058-1.054c0-.54.409-.985.934-1.046l.124-.007h3.203zm-6.692-15.611c.393.392.423 1.01.091 1.436l-.09.103-3.131 3.13a1.088 1.088 0 01-1.63-1.436l.09-.103 3.131-3.13a1.09 1.09 0 011.54 0zm-30.881.064l.1.087 2.266 2.258a1.05 1.05 0 010 1.49c-.381.379-.98.408-1.396.087l-.1-.088-2.266-2.257a1.05 1.05 0 010-1.49 1.06 1.06 0 011.396-.087zM50.89 7.364c.542 0 .99.407 1.05.93l.007.123v3.19c0 .582-.473 1.054-1.057 1.054-.542 0-.99-.407-1.05-.93l-.007-.123v-3.19c0-.583.473-1.054 1.057-1.054z"
})));

function SvgErrorIllustration(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 102,
    height: 100
  }, props), _ref, _ref2);
}

export default SvgErrorIllustration;